import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { UsPreJoinWizard } from "../../../../components/features/onboarding/us/pre-join/us-pre-join-wizard.tsx";
// Reuse the existing public onboarding shell without modifying the current flow.
import styles from "../../../onboard-pre-join/create-employee-page.module.css";

const HERO_CARD_BG = "/assets/images/onboarding-form-card-bg.png";
export default function UsPreJoinPage() {
  const [params] = useSearchParams();
  const token = params.get("token")?.trim() ?? "";
  const [submitted, setSubmitted] = useState(false);
  return <div className={styles.page} data-theme="caelius-classic">
    <header className={styles.topBar}><img className={styles.logo} src="/assets/images/logo.svg" alt="Caelius Consulting Logo" width={150} /></header>
    <main className={styles.main}><div className={styles.inner}>
      {!submitted && <section className={styles.heroCard} style={{ backgroundImage: `url(${HERO_CARD_BG})` }}><h1 className={styles.heroTitle}> Hello & Welcome to Caelius Consulting!
</h1><div className={styles.heroLine} /><p className={`body-sm ${styles.heroIntro}`}>We’re delighted to have you on board. Please provide the required details to ensure a smooth and seamless onboarding journey.

      </p></section>}
      {!token ? <p className={`body-sm ${styles.error}`} role="alert">Open this page with a token. For local testing use: ?token=mock-us-prejoin</p> : <UsPreJoinWizard token={token} onSubmitted={() => setSubmitted(true)} />}
    </div></main>
  </div>;
}
